import styled from 'styled-components';
import { Box } from '@mui/material';
import { BoxPaper } from 'spw-shared/globalComponents/containers';

export const ProjectPaper = styled(BoxPaper)`
  && {
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.12);
    box-sizing: border-box;
    grid-row-end: auto !important;

    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2), 0px 2px 1px rgba(0, 0, 0, 0.12),
      0px 1px 1px rgba(0, 0, 0, 0.14);
    border-radius: 4px;
  }
`;

export const ProjectTitle = styled(Box)`
  flex: 1;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 32px;
  cursor: pointer;
  color: #000000;
`;
export const BuildingText = styled(Box)`
  flex: 0;
  font-family: Roboto;
  font-style: normal;
  font-size: 18px;
  cursor: pointer;
  color: #000000;
  flex-basis: auto;

  &.export-title {
    margin: 15px;
  }

  &.text-center {
    text-align: center;
  }
`;

export const ProcessingOverlay = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
